import styled, {css} from 'styled-components';

import {media} from '~/shared/theme/media';

const PieModalHeader = styled.div<{hideOnMobile?: boolean}>`
  height: 56px;
  width: 100%;
  ${({hideOnMobile}) => hideOnMobile && css`
    display: none;
    ${media.minLargeMobile`
      display: block;
    `}
  `}
`;

export default PieModalHeader;
